import styled from "styled-components";
import { Link } from "react-router-dom";
import { checkedInColors, checkedInFonts } from "./CheckedInStyles";
import logo from "src/img/checked-in/logo-horizontal-cream.png";

export const CheckedInSiteRoot = styled.div`
    ${checkedInFonts}
    min-height: 100vh;
    min-height: 100dvh;
    background: var(--checked-in-background);
    color: var(--checked-in-primary);
    font-family: Archivo, sans-serif;
    font-weight: 400;
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    grid-template-rows: auto auto 1fr;
    *, *::before, *::after { box-sizing: border-box; }
    button, input { font-family: inherit; }
    button, a { -webkit-tap-highlight-color: transparent; }
    :focus-visible { outline: 3px solid var(--checked-in-primary); outline-offset: 3px; }
    @media (min-width: 960px) { grid-template-columns: 240px minmax(0, 1fr); grid-template-rows: auto 1fr; }
`;

export const CheckedInSiteHeader = styled.header`
    grid-column: 1 / -1;
    position: sticky;
    top: 0;
    z-index: 20;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
    min-height: 64px;
    padding: 12px 20px;
    background: var(--checked-in-background);
    border-bottom: 1px solid color-mix(in srgb, var(--checked-in-primary) 12%, transparent);
    @media (min-width: 960px) { button { display: none; } }
`;

export const CheckedInBrand = styled(Link)`
    display: block;
    width: 200px;
    max-width: 65%;
    height: 30px;
    background: var(--checked-in-primary);
    mask: url(${logo}) left center / contain no-repeat;
`;

export const CheckedInSiteNav = styled.nav<{ $open: boolean }>`
    grid-row: 2;
    display: ${p => p.$open ? "flex" : "none"};
    flex-direction: column;
    gap: 12px;
    padding: 24px;
    background: var(--checked-in-background);
    a { color: inherit; text-underline-offset: 3px; }
    > a[href^="/"] { font-weight: 600; padding: 12px 0; }
    @media (min-width: 960px) {
        display: flex;
        position: sticky;
        top: 64px;
        align-self: start;
        min-height: calc(100dvh - 64px);
    }
`;

export const CheckedInSiteMain = styled.main`
    grid-row: 3;
    min-width: 0;
    width: 100%;
    max-width: 1100px;
    margin: 0 auto;
    background: #fff;
    @media (min-width: 960px) { grid-column: 2; grid-row: 2; }
`;

export const CheckedInAction = styled.button<{ $outline?: boolean; $round?: boolean; $monochrome?: boolean }>`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    align-self: start;
    min-height: 44px;
    min-width: 44px;
    padding: ${p => p.$round ? "10px" : "10px 20px"};
    border-radius: 999px;
    border: 1px solid ${p => p.$monochrome ? checkedInColors.black : "var(--checked-in-primary)"};
    background: ${p => p.$outline ? "transparent" : p.$monochrome ? checkedInColors.black : "var(--checked-in-primary)"};
    color: ${p => p.$outline ? p.$monochrome ? checkedInColors.black : "var(--checked-in-primary)"
        : p.$monochrome ? checkedInColors.white : "var(--checked-in-background)"};
    font-weight: 600;
    font-size: 16px;
    cursor: pointer;
    text-decoration: none;
    &:disabled { opacity: 0.5; cursor: default; }
    svg { width: 22px; height: 22px; flex: 0 0 auto; }
`;
